const initialState = {
  user: {},
};

export default function authReducer(state = initialState, action) {
  const logAuth = false;

  if (logAuth) console.log("in auth reducer", action);
  switch (action.type) {
    case "CURRENT_USER":
      if (logAuth) console.log("current user", action);
      return { ...state, user: action.payload };
    case "AAD_LOGIN_FAILED":
      if (logAuth) console.log("longin failed", action);
      return { ...state, aadResponse: null };
    case "AAD_LOGIN_ERROR":
      if (logAuth) console.log("login error", action);
      return { ...state, aadResponse: action.payload };
    case "AAD_LOGIN_SUCCESS":
      if (logAuth) console.log("login success", action);
      return { ...state, aadResponse: action.payload };
    case "SET_TOKEN":
      if (logAuth) console.log("set token case", action);
      return Object.assign({}, state, {
        jwtIdToken: Object.assign(
          {},
          state.aadResponse.jwtIdToken,
          action.payload
        ),
      });
    case "msal:acquireTokenSuccess":
      if (logAuth) console.log("msal:acquireTokenSuccess", action);
      return Object.assign({}, state, {
        jwtIdToken: Object.assign({}, state, action.payload),
      });
    default:
      if (logAuth) console.log("default", state);
      return state;
  }
}
